import { useSelector } from "react-redux";
import styles from "../../../../styles/Components/new-insight/create-strategy/CreateStrategyForm.module.css";
import { Select } from "antd";
import { useStrategy } from "../useCreateStrategyContext";
const { Option } = Select;

function StrategyName() {
  const {
    newInsightState: { createStrategyResult },
  } = useSelector((state) => state);

  const { strategy_name: name, strategy_names: suggestions } =
    createStrategyResult;

  const allNames = [name, ...suggestions];

  const {
    state: { strategyName },
    setName,
  } = useStrategy();

  return (
    <div className={styles.formItem}>
      <h5 className={styles.label}>Name:</h5>
      <div className={styles.editBox}>
        <Select value={strategyName} onChange={setName}>
          {allNames.map((suggestion, index) => (
            <Option key={index} value={suggestion}>
              {suggestion}
            </Option>
          ))}
        </Select>
      </div>
      {/*{!isEditing && (*/}
      {/*  <div className={styles.formInput}>*/}
      {/*    <span className={styles.value}>{selectedName || name}</span>*/}
      {/*    <span*/}
      {/*      className={styles.edit}*/}
      {/*      onClick={() => {*/}
      {/*        setIsEditing(true);*/}
      {/*        setSelectedName(suggestions?.[0]);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <FaRegEdit size={16} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*{isEditing && (*/}
      {/*  <div className={styles.editBox}>*/}
      {/*    <Select value={selectedName} onChange={setSelectedName}>*/}
      {/*      {suggestions.map((suggestion, index) => (*/}
      {/*        <Option key={index} value={suggestion}>*/}
      {/*          {suggestion}*/}
      {/*        </Option>*/}
      {/*      ))}*/}
      {/*    </Select>*/}
      {/*    <span*/}
      {/*      className={styles.submitEdit}*/}
      {/*      onClick={() => setIsEditing(false)}*/}
      {/*    >*/}
      {/*      <FaCircleCheck size={18} />*/}
      {/*    </span>*/}
      {/*    <span*/}
      {/*      className={styles.closeEdit}*/}
      {/*      onClick={() => {*/}
      {/*        setSelectedName("");*/}
      {/*        setIsEditing(false);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <IoIosCloseCircle size={22} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}

export default StrategyName;
